import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import BasketModel from "../../model/BasketModel";

export class ComBasketCountStore {

    count = 0;
    private rootStore: RootStore | undefined;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    @action
    init() {
        this.reload();
    }

    reload() {
        BasketModel.getBasketSmall(this.rootStore?.mainStore.clientId, this.setData, this.setError)
    }

    @action
    setData = (result: any) => {
        if (result.data) {
            this.count = result.data.length;
        } else {
            this.count = 0;
        }
    }

    @action
    setError = (error: any) => {
        console.log(error);
    }
}